<template>
	<div class="manage_app p_background clearfix">
	<h3 class="all_title">校园信息列表</h3>
	<div class="school_add h3 container_box">
		<!--<button class="btn btn_issue" @click="school_add">新增</button>-->
	</div>
	<div class="table_box user-select clearfix container_box">
		<table class="table table-hover text-center">
			<thead>
				<tr>
					<th>学校名称</th>
					<th>学校URL</th>
					<th>学校地址</th>
					<th>操作</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in serviceSchoolList">
					<td>
						{{item.schoolName}}
					</td>
					<td>{{item.schoolUrl}}</td>
					<td v-if="'' != item.province && null != item.province">{{item.province}}/{{item.city}}/{{item.county}}</td>
					<td v-else></td>
					<td><a class="cursor" @click="school_edit(item.id)">修改</a>&nbsp;&nbsp;<a class="cursor" @click="school_del(item.id)">删除</a></td>
				</tr>
				<tr v-if="serviceSchoolList.length < 1 ">
					<td colspan="4">暂无数据！</td>
				</tr>
			</tbody>
		</table>
		<!-- table  end -->
	</div>
	
		<!--分页 start-->
			<div v-bind:class="page.totalPages > 0 ? 'show' : 'hidden'" class="text-center">
				<div class="row-fluid">
					<nav>
						<ul class="pagination">
							<li class="disabled" v-bind:class="page.first ? 'disabled' : ''">
								<a style="cursor: pointer;" @click="turnPage(page.url,page.previousPage)" aria-label="Previous">
									<span aria-hidden="true">&laquo;</span>
								</a>
							</li>
							<li v-for="i in page.totalPages" v-bind:class="page.number==(i-1)?'active':''">
								<a style="cursor: pointer;" @click="turnPage(page.url,i-1)" v-text="i">1</a>
							</li>
							<li v-bind:class="page.last ? 'disabled' : ''">
								<a style="cursor: pointer;" @click="turnPage(page.url,page.nextPage)" aria-label="Next">
									<span aria-hidden="true">&raquo;</span>
								</a>
							</li>
						</ul>
					</nav>
				</div>
			</div>
			<!--分页 end-->
			
		<!--confirm-->
		<v-confirm v-if="confirmFlag" :bigMsg="bigMsg" @confirmOff="confirmFlag = !confirmFlag" @confirmTrue="confirm_del"></v-confirm>
	</div>
</template>

<script>
	import { MessageBox } from 'element-ui'
	
	export default {
		name: 'service_school',
		data(){
			return {
				bigMsg: '',
				confirmFlag: false,
				delId: '',
				page: '',
				serviceSchoolList: ''
			}
		},
		created: function(){
			this.getSchoolList();
		},
		methods: {
			getSchoolList(){
				var temp = this;
				this.$http.post('/zklccloud/findServiceSchoolList', {
					emulateJSON: true
				}).then(function(m) {
					temp.serviceSchoolList = m.body.content.page.page.content,
					temp.page = m.body.content.page
				})
			},
			turnPage(pageUrl, page) {
				var temp = this;
				this.$http.post('/zklccloud/' + pageUrl, {
					"page": page,
					"size": 10
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.serviceSchoolList = m.body.content.page.page.content,
					temp.page = m.body.content.page
				})
			},
			school_add(){
				this.$router.push({
					name: 'schoolinfo_add',
					params: {
						title: '新增'
					}
				});
			},
			school_edit(id){
				this.$router.push({
					name: 'schoolinfo_edit',
					params: {
						eid: id,
						title: '修改'
					}
				});
			},
			school_del(id){
				this.delId = id;
				this.confirmFlag = true;
				this.bigMsg = "确定删除这条数据吗？";
			},
			confirm_del(){
				var temp = this;
				var id = this.delId;
				//确认删除
				this.$http.post('/zklccloud/delServiceSchoolInfo', {
					"id": id
				}, {
					emulateJSON: true
				}).then(function(m) {
					if(m.body.resultCode == '0'){
						MessageBox('删除成功！', '提示', 'success', {
							confirmButtonText: '确定',
						});
						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						temp.confirmFlag = false;
						temp.$nextTick(function() {
							this.getSchoolList();
						})
					}else{
						MessageBox('操作失败，请联系管理员！', '提示', 'warning', {
							confirmButtonText: '确定',
						});
					}
				})
			}
		}
	}
</script>

<style>
	.btn_issue{
		min-width: 64px!important;
	}
	
	.school_add{
		margin-bottom: 15px;
	}
</style>


// WEBPACK FOOTER //
// service_school.vue?6d78c1e6